import { useRef, useEffect } from "react";
import { useApp } from "../../hooks/AppProvider";

function Log2(props) {
    let app = useApp();
    let passwordInputRef = useRef(null);
    let passwordCInputRef = useRef(null);

    useEffect(() => {
        if(passwordInputRef.current) {
            passwordInputRef.current.focus();
        }
    }, []);
    

    function changePassword(e) {
        props.setStatusMessage("");
        props.setPassword(e.target.value);
    }

    function changeCPassword(e) {
        props.setStatusMessage("");
        props.setCPassword(e.target.value);
    }

    function changeUsername(e) {
        props.setPassword("");
        props.setUsername(e.target.value);
        props.setState(0);
    }

    function create() {

        if(props.password.length < 8) {
            props.setStatusMessage("le mot de passe doit faire au minimum 8 caractères");
            return;
        }

        if(props.password !== props.cPassword) {
            props.setStatusMessage("les mots de passe ne sont pas identique");
            passwordInputRef.current.select();
            passwordInputRef.current.focus();
            props.setCPassword("");
            return;
        }

        app.sendPost("/auth/login/2", {username: props.username, password: props.password}, data => {
            if(app.emptyCheck(data.next))
                return props.setStatusMessage("Une erreur c'est produite");

            props.setState(data.next);
        });
    }

    function handleNext(e) {
        if(e.key === "Enter") {
            e.preventDefault();
            passwordCInputRef.current.focus();
        }
    }

    function handleCreate(e) {
        if(e.key === "Enter") {
            e.preventDefault();
            create();
        }
    }

    return (
        <>
            <span className="login-label">Nom d'utilisateur</span>
            <input value={props.username} onChange={changeUsername} placeholder="Nom d'utilisateur"></input>

            <span className="login-label">Mot de passe</span>
            <input ref={passwordInputRef} type="password" value={props.password} onChange={changePassword} onKeyDown={handleNext} placeholder="Mot de passe"></input>

            <span className="login-label">Confirmation</span>
            <input ref={passwordCInputRef} type="password" value={props.cPassword} onChange={changeCPassword} onKeyDown={handleCreate} placeholder="Confirmation"></input>

            <button onClick={create}>Créer</button>
        </>
    )
}

export default Log2;